import { FC, useState, useEffect } from 'react'

import { useSetFocus } from '@please/lrud'
import { useNavigate } from 'react-router-dom'

import { orientation, focusIds } from '@/constants/focus'
import { popupStatus } from '@/constants/popup'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'
import { getMainHomePath } from '@/utils/route'

import {
  PageFallbackButtons,
  PageFallbackText,
  PageFallbackWrapper,
} from './styles'
import { PageFallbackProps } from './types'
import { Button } from '../Button/Button'

const focusId = `${focusIds.PAGE_FALLBACK}_${focusIds.BUTTON}`

export const PageFallback: FC<PageFallbackProps> = ({
  reloadHandler,
  width,
  height,
}) => {
  const { t } = useCommonTranslation()
  const setSubMenuType = useStore((state) => state.common.setSubMenuType)
  const { pagePopupStatus, closePagePopup } = useStore((state) => state.popup)
  const isPagePopupOpen = pagePopupStatus !== popupStatus.CLOSED

  const [focusChild, setFocusChild] = useState(0)

  const setFocus = useSetFocus()
  const navigate = useNavigate()

  useEffect(() => {
    setFocus(focusId)
  }, [])

  const reloadPage = () => {
    reloadHandler?.()
  }

  const goToHome = () => {
    setSubMenuType(null)
    navigate(getMainHomePath())
    isPagePopupOpen && closePagePopup()
  }

  const handleMove = (e: MoveEvent) => {
    setFocusChild(e.nextChildIndex)
  }

  return (
    <PageFallbackWrapper $width={width} $height={height}>
      <PageFallbackText>{t('pageFallback.content')}</PageFallbackText>
      <PageFallbackButtons
        focusId={focusId}
        defaultFocusChild={focusChild}
        onMove={handleMove}
        orientation={orientation.HORIZONTAL}
      >
        <Button text={t('pageFallback.buttons.0')} onClick={reloadPage} />
        <Button text={t('pageFallback.buttons.1')} onClick={goToHome} />
      </PageFallbackButtons>
    </PageFallbackWrapper>
  )
}
